export default __webpack_public_path__ + "static/media/Armbands of the Revelations of Tarim.3a9f68a1.jpg";